/*
 * Woolman Common JS
 */
// Initialize window.Woolman object
if (typeof window.Woolman == 'undefined') {
  window.Woolman = {};
}
Woolman.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

// -------
// Load components / libraries
Woolman.init = function () {
  Woolman.ModalsAndDrawers.init();
  Woolman.Header.init();
  Woolman.Bundle.init();
  if (theme.settings.enableWishlist) {
    Woolman.Wishlist.init();
  }

  const currentCountryName = Woolman.geoInfo.countryJson.find(o => o.isocode == Shopify.country)?.name;

  if (currentCountryName) {
    document.querySelectorAll('[data-current-country-name]').forEach((element) => {
      element.textContent = currentCountryName;
    });
  }

  // Attach theme editor listeners
  if (!Shopify || !Shopify.designMode) return;

  let lastSelection = {
    sectionId: undefined,
    blockId: undefined
  };

  // Load is called when something is changed within section settings
  document.addEventListener('shopify:section:load', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    if (sectionId === Woolman.Header.cache.section.id) {
      Woolman.ModalsAndDrawers.init();
      Woolman.Header.init();
    }

    if (document.getElementById(sectionId).querySelector('slider-component')) {
      const slider = document.getElementById(sectionId).querySelector('slider-component')
      const config = slider.dataset.splideConfig;
      if (!config) return;

      new Splide(slider, config)
    } else if (document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('shopify:section:load sectionId', evt.detail.sectionId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:block:select', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    const blocks = document.getElementById(sectionId).querySelectorAll('[data-shopify-editor-block]')
    const selectedBlock = [...blocks].find(x => JSON.parse(x.dataset.shopifyEditorBlock).id === evt.detail.blockId);
    if (sectionId === Woolman.Header.cache.section.id) {
      if (selectedBlock) {
       // Make sure menu is open
        Woolman.Header.cache.openButton.click();

        // Select menu item
        const accordion = selectedBlock.closest('[data-accordion-item]').querySelector('input');
        const label = selectedBlock.closest('[data-accordion-item]').querySelector('label');
        if (!accordion.checked) label.click();
      }
    } else if (sectionId.includes('modal') && document.getElementById(sectionId).querySelector('[data-modal]')) {
      if (selectedBlock) {
        Woolman.ModalsAndDrawers.showModalOrDrawer(document.getElementById(sectionId).querySelector('[data-modal]').id);
      }
    }

    lastSelection.sectionId = evt.detail.sectionId;
    lastSelection.blockId = evt.detail.blockId;
    console.log('shopify:block:select', evt.detail.sectionId, evt.detail.blockId)
    console.log('lastSelection', lastSelection);
  });

  document.addEventListener('shopify:section:unload', (evt) => {
    console.log('shopify:section:unload sectionId', evt.detail.sectionId)
  });

  document.addEventListener('shopify:section:select', (evt) => {
    console.log('shopify:section:select', evt.detail.sectionId)
    lastSelection = {
      sectionId: evt.detail.sectionId,
      blockId: evt.detail.blockId
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  });

  document.addEventListener('shopify:section:deselect', (evt) => {
    console.log('shopify:section:deselect', evt.detail.sectionId)
    lastSelection = {
      sectionId: undefined,
      blockId: undefined
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.closeModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  });
};

// -------
// Woolman Common JS - Utility library
Woolman.Utils = {
  debugMode: false,
  focusTraps: {},
  checkCanFocusTrap: (trapContainers) => {
    const results = trapContainers.map((trapContainer) => {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (getComputedStyle(trapContainer).visibility !== 'hidden') {
            resolve();
            clearInterval(interval);
          }
        }, 5);
      });
    });
    // Return a promise that resolves when all the trap containers are able to receive focus
    return Promise.all(results);
  },
  onFocusTrapDeactivate: (targetElement) => {
    targetElement.classList.remove('focus-trap');
    document.body.classList.remove('focus-being-trapped');
  },
  onFocusTrapActivate: (targetElement) => {
    targetElement.classList.add('focus-trap');
    document.body.classList.add('focus-being-trapped');
  },
  clearFocusTrap: (cacheKey) => {
    if (Woolman.Utils.focusTraps[cacheKey]) {
      Woolman.Utils.focusTraps[cacheKey].deactivate();
      Woolman.Utils.focusTraps[cacheKey] = undefined;
    }
  },
  prepareQueryParams: () => {
    Shopify.queryParams = Shopify.queryParams || {};

    // Preserve existing query parameters
    if (location.search.length) {
      const params = location.search.substr(1).split('&');

      for (let i = 0; i < params.length; i++) {
        const keyValue = params[i].split('=');

        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
        }
      }
    }

    return Shopify.queryParams;
  },
  formatMoney(cents, format) {
    var default_money_format = Woolman.moneyFormat;
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || default_money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },
};

// -------
// Woolman Common JS - Header component
Woolman.Header = {
  selectors: {
    header: 'MainHeader',
    search: '[data-header-search]',
    searchOpen: `a[href="${routes.search_url}"]`,
    searchClose: '.header-search__close',
    cartBlip: '.cart-blip'
  },
  cache: {
    header: undefined,
    search: undefined,
    searchOpen: undefined,
    searchClose: undefined,
    cartBlip: undefined,
    section: undefined,
    openButton: undefined
  },
  focusTraps: {},

  init: function () {
    this.cache.header = document.getElementById(this.selectors.header);
    if (this.cache.header) {
      this.cache.search = this.cache.header.querySelector(this.selectors.search);
      this.cache.searchOpen = this.cache.header.querySelectorAll(this.selectors.searchOpen);
      this.cache.searchClose = this.cache.header.querySelector(this.selectors.searchClose);
      this.cache.cartBlip = this.cache.header.querySelector(this.selectors.cartBlip);
      this.cache.section = this.cache.header.closest('.shopify-section');
      this.cache.openButton = this.cache.header.querySelector('[href="#drawer-menu"]')

      if (this.cache.searchOpen && this.cache.searchClose) {
        this.cache.searchOpen.forEach((button) => {
          button.addEventListener('click', this.onSearchOpen.bind(this));
        })
        this.cache.searchClose.addEventListener('click', this.onSearchClose.bind(this));
      }

      // Update cart blip when product is added to cart.
      document.addEventListener('ajaxProduct:added', this.updateCartBlip.bind(this))
      document.addEventListener('ajaxProduct:cleared', this.updateCartBlip.bind(this))
      document.addEventListener('cart:update', this.updateCartBlip.bind(this));

      if (this.cache.header.dataset.stickyBehavior === 'none') return;
      this.initStickyBehavior(this.cache.header.dataset.stickyBehavior)
    }
  },

  onSearchOpen(event) {
    event.preventDefault();

    const targetElement = this.cache.search;
    Woolman.Utils.focusTraps['search'] = focusTrap.createFocusTrap(targetElement, {
      escapeDeactivates: true,
      checkCanFocusTrap: Woolman.Utils.checkCanFocusTrap,
      onActivate: () => {
        targetElement.classList.add('is-open');
        Woolman.Utils.onFocusTrapActivate(targetElement);
        bodyScrollLock.disableBodyScroll(targetElement);
        setTimeout(() => {
          targetElement.classList.add('animation')
        })
      },
      onDeactivate: () => {
        targetElement.classList.remove('animation')
        bodyScrollLock.enableBodyScroll(targetElement);
        Woolman.Utils.onFocusTrapDeactivate(targetElement);
        setTimeout(() => {
          targetElement.classList.remove('is-open');
        })
      },
    });

    Woolman.Utils.focusTraps['search'].activate();
  },

  onSearchClose(event) {
    event.preventDefault();
    Woolman.Utils.clearFocusTrap('search');
  },

  initStickyBehavior(behaviorType) {
    const stickyConfig = {
      headerHeight: this.cache.header.clientHeight,
      behavior: behaviorType
    }

    document.documentElement.classList.add('sticky-header-initialized', `sticky-header-${behaviorType}`);
    document.documentElement.style.setProperty('--sticky-header-margin-top', `${stickyConfig.headerHeight}px`);

    if (behaviorType === 'scroll' || behaviorType === 'fixed') {
      // Show on scroll fixed header
      let prevScroll = window.scrollY || document.documentElement.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      const toggleStickyHeader = (direction, curScroll) => {
        if ((direction === 1) || curScroll < stickyConfig.headerHeight) {
          document.documentElement.classList.remove('sticky-header-hide')
        } else if (direction === 2 && curScroll > stickyConfig.headerHeight) {
          document.documentElement.classList.add('sticky-header-hide')
        }

        prevDirection = direction;
      }

      window.addEventListener('scroll', throttle(() => {
        curScroll = window.scrollY || document.documentElement.scrollTop;

        if (curScroll >= 300) {
          document.documentElement.classList.add('sticky-header-show')
        } else {
          document.documentElement.classList.remove('sticky-header-show');
        }

        if (curScroll > prevScroll) {
          direction = 2; // user scrolling down
        } else {
          direction = 1; // user scrolling up
        }

        if (direction !== prevDirection && behaviorType === 'scroll') {
          toggleStickyHeader(direction, curScroll)
        }

        prevScroll = curScroll
      }, 50))

      setInterval(() => {
        if (direction === 2 && behaviorType === 'scroll' && curScroll >= 900) {
          toggleStickyHeader(direction, curScroll);
        }
        if (window.scrollY === 0) {
          document.documentElement.classList.remove('sticky-header-show', 'sticky-header-hide');
        }
      }, 200)
    }
  },

  async updateCartBlip(e) {
    const cart = e.detail.json && e.detail.json.cart && e.detail.json.cart.item_count || await (async function () {
      return window.fetchCart();
    })();

    const bundlesList = new Set();
    let cartItemCount = 0;

    for (const item of cart.items) {
      if (item.properties && item.properties['_bundleKey'] !== undefined) {
        const bundleKey = item.properties['_bundleKey'];

        if (!bundlesList.has(bundleKey)) {
          bundlesList.add(bundleKey);
          cartItemCount += item.quantity;
        }
      } else {
        cartItemCount += item.quantity;
      }
    }

    this.cache.cartBlip.textContent = cartItemCount || 0;
    if (cart && cartItemCount == 0) {
      this.cache.cartBlip.setAttribute('hidden', true);
      this.cache.cartBlip.closest('.header-item__link').classList.remove('has-blip-visible');
    } else {
      this.cache.cartBlip.removeAttribute('hidden')
      this.cache.cartBlip.closest('.header-item__link').classList.add('has-blip-visible');
    }
  }
};

// -------
// Woolman Common JS - Modals & drawers library
Woolman.ModalsAndDrawers = {
  settings: {
    selectors: {
      modalLink: 'a[href*="modal"]',
      drawerLink: 'a[href*="drawer"]',
    },
  },
  focusTraps: {},
  init: function () {
    document.querySelectorAll(this.settings.selectors.modalLink).forEach((modalLink) => {
      modalLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1);
        this.showModalOrDrawer(targetId);
      });
    });

    document.querySelectorAll(this.settings.selectors.drawerLink).forEach((drawerLink) => {
      drawerLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1);
        this.showModalOrDrawer(targetId);
      });
    });
  },
  /**
   *
   * @param {string} targetId - ID of modal or drawer element, e.g. modal-geo, drawer-menu
   * Traps focus to modal and disables body scrolling.
   * Focus trap utilizes focus-trap library: https://github.com/focus-trap/focus-trap
   */
  showModalOrDrawer: function (targetId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement && Woolman.Utils.debugMode) {
      console.warn('No modal/drawer element specified');
    }
    if (!targetElement) {
      return;
    }

    if (targetElement.classList.contains('is-open')) return;

    targetElement.classList.add('initialized', 'is-open');

    if (!Woolman.Utils.focusTraps[targetId]) {
      const trapTarget = targetElement.querySelector('[data-contents') || targetElement;
      Woolman.Utils.focusTraps[targetId] = focusTrap.createFocusTrap(trapTarget, {
        clickOutsideDeactivates: true,
        escapeDeactivates: true,

        // Called before focus is sent
        onActivate: () => {
          Woolman.Utils.onFocusTrapActivate(targetElement);

          const closeBtns = targetElement.querySelectorAll('[data-close]');
          if (closeBtns) {
            closeBtns.forEach((closeBtn) => {
              closeBtn.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
            });
          }

          if (targetId != 'modal-geo') {
            const overlay = targetElement.querySelector('[data-overlay]');
            if (overlay) {
              overlay.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
            }
          }

          bodyScrollLock.disableBodyScroll(targetElement);
          document.dispatchEvent(new CustomEvent(`drawerOrModalOpen.${targetId}`));
        },

        // There is a delay between when the class is applied
        // and when the element is focusable
        checkCanFocusTrap: Woolman.Utils.checkCanFocusTrap,

        // Called after focus is deactivated
        onDeactivate: () => {
          targetElement.querySelectorAll('[data-close]').forEach((closeBtn) => {
            closeBtn.removeEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
          });

          const overlay = targetElement.querySelector('[data-overlay]');
          if (overlay) {
            overlay.click();
            overlay.removeEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
          }
          bodyScrollLock.enableBodyScroll(targetElement);
          Woolman.Utils.onFocusTrapDeactivate(targetElement);

          document.dispatchEvent(new CustomEvent(`drawerOrModalClose.${targetId}`));
        },
      });
    }

    Woolman.Utils.focusTraps[targetId].activate();
  },
  /**
   *
   * @param {string} targetId - ID of target element, e.g. modal-geo, drawer-menu
   * Removes trapped focus when modal is closed by e.g. using the close button.
   */
  closeModalOrDrawer: function (targetId) {
    if (Woolman.Utils.focusTraps[targetId]) {
      Woolman.Utils.focusTraps[targetId].deactivate();
      Woolman.Utils.focusTraps[targetId] = undefined;
    }
  },
  closeModalOrDrawerOrDrawerFromEvent: function (event) {
    event.preventDefault();
    const parentElement = event.currentTarget.closest('[data-parent]');
    const targetId = parentElement.getAttribute('id');
    parentElement.classList.remove('is-open');
    this.closeModalOrDrawer(targetId);
  },
};

Woolman.Wishlist = {
  settings: {
    cookieKey: 'Woolman_Wishlist',
    selectors: {
      trigger: '[data-wishlist-trigger]',
      wishlistBlip: '[data-wishlist-blip]'
    },
  },
  init: function () {
    const wishlist = Cookies.get(this.settings.cookieKey) ? Cookies.get(this.settings.cookieKey).split(',') : [];

    document.querySelectorAll(this.settings.selectors.trigger).forEach(function(wishlistTrigger) {
      if (wishlistTrigger && !wishlistTrigger.dataset.mutated) {
        if (wishlist.includes(wishlistTrigger.dataset.handle)) {
          wishlistTrigger.classList.add('active');
        }

        wishlistTrigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.handleClick(event.currentTarget);
        });

        wishlistTrigger.dataset.mutated = true;
      }
    }.bind(this));

    document.addEventListener('card:loaded', event => {
      event.detail.querySelectorAll(this.settings.selectors.trigger).forEach(function(wishlistTrigger) {
        if (wishlistTrigger && !wishlistTrigger.dataset.mutated) {
          if (wishlist.includes(wishlistTrigger.dataset.handle)) {
            wishlistTrigger.classList.add('active');
          }

          wishlistTrigger.addEventListener('click', (event) => {
            event.preventDefault();
            this.handleClick(event.currentTarget);
          });

          wishlistTrigger.dataset.mutated = true;
        }
      }.bind(this));
    });

    this.updateWishlistBlip();
  },

  updateWishlistBlip: function() {
    const wishlist = Cookies.get(this.settings.cookieKey) ? Cookies.get(this.settings.cookieKey).split(',') : [];
    const wishlistBlips = document.querySelectorAll(this.settings.selectors.wishlistBlip);

    wishlistBlips.forEach(wishlistBlip => {
      wishlistBlip.textContent = wishlist.length;

      if (wishlist.length == 0) {
        wishlistBlip.setAttribute('hidden', true);
        wishlistBlip.closest('.header-item__link')?.classList.remove('has-blip-visible');
      } else {
        wishlistBlip.removeAttribute('hidden')
        wishlistBlip.closest('.header-item__link')?.classList.add('has-blip-visible');
      }
    });
  },

  handleClick: function (wishlistTrigger) {
    const productHandle = wishlistTrigger.dataset.handle;
    let wishlist = Cookies.get(this.settings.cookieKey) ? Cookies.get(this.settings.cookieKey).split(',') : [];

    if (wishlist.includes(productHandle)) {
      this.remove(productHandle);
    } else {
      this.add(productHandle);
    }

    document.querySelectorAll(`${this.settings.selectors.trigger}[data-handle="${productHandle}"]`).forEach(el => {
      el.classList.toggle('active');
    });
  },

  add: function (productHandle) {
    const wishlist = Cookies.get(this.settings.cookieKey) ? Cookies.get(this.settings.cookieKey).split(',') : [];
    wishlist.unshift(productHandle);
    Cookies.set(this.settings.cookieKey, wishlist.join(','));

    const event = new CustomEvent('wishlist:add', {
      detail: productHandle,
    });

    document.dispatchEvent(event);
    this.updateWishlistBlip();
  },

  remove: function (productHandle) {
    let wishlist = Cookies.get(this.settings.cookieKey) ? Cookies.get(this.settings.cookieKey).split(',') : [];
    wishlist = wishlist.filter(e => e !== productHandle);
    Cookies.set(this.settings.cookieKey, wishlist.join(','));

    const event = new CustomEvent('wishlist:remove', {
      detail: productHandle,
    });

    document.dispatchEvent(event);
    this.updateWishlistBlip();
  }
}

Woolman.Marketing = {
  getUTMParametersFromURL: function() {
    const urlObj = new URL(window.location.href);
    const utmParameters = {};

    // Loop through all search parameters
    urlObj.searchParams.forEach((value, key) => {
      // Check if the parameter name starts with "utm_"
      if (key.startsWith('utm_') || key === 'gclid') {
        utmParameters[key] = value;
      }
    });

    return utmParameters;
  }
}

Woolman.Bundle = {
  settings: {
    selectors: {
      bundleCard: '[data-bundle-product]',
    },
  },

  init: function () {
    document.querySelectorAll(this.settings.selectors.bundleCard).forEach(function(card) {
      this.updateBundleProductCard(card);
    }.bind(this));

    document.addEventListener('card:loaded', event => {
      if (event.detail.dataset.bundleProduct) this.updateBundleProductCard(event.detail);
    });

    // this.checkCart();
  },

  addBundlePricesFromElement: function (element) {
    element.querySelectorAll(this.settings.selectors.bundleCard).forEach(function(card) {
      this.updateBundleProductCard(card);
    }.bind(this));
  },

  updateBundleProductCard: function (card) {
    const productHandles = card.dataset.handles.split(',');
    const discountPercentage = parseInt(card.dataset.discount) || 0;

    const fetchProduct = async (handle) => {
      try {
        const rootUrl = window.Shopify.routes.root == '/' ? '/' : window.Shopify.routes.root + '/'; // if user has selected locale convert root url from /en-gb to /en-gb/
        const response = await fetch(`${rootUrl}products/${handle}?view=bundle-child`);
        const data = await response.text();

        const selectedVariant = new DOMParser().parseFromString(data, 'text/html').querySelector('[data-selected-variant]').textContent;
        const selectedVariantJson = JSON.parse(selectedVariant);

        const { compare_at_price, price } = selectedVariantJson;
        return parseInt(compare_at_price || price);
      } catch (error) {
        console.log(error);
        return 0;
      }
    };

    const fetchAllProducts = async () => {
      if (productHandles.length === 0) {
        return 0;
      }
      const prices = await Promise.all(productHandles.map(fetchProduct));
      return prices.reduce((sum, price) => sum + price, 0);
    };

    fetchAllProducts()
      .then((totalPrice) => {
        // Update the card with the total price
        card.querySelector('.price-item--regular').innerHTML =
          window.variantStrings.price.from_price_html.replace('[price]', Woolman.Utils.formatMoney(totalPrice));
        card.querySelector('.price-item--sale')
          ? card.querySelector('.price-item--sale').innerHTML = window.variantStrings.price.from_price_html.replace('[price]', Woolman.Utils.formatMoney(totalPrice * ((100 - discountPercentage) / 100)))
          : '';
      })
      .catch((error) => console.log(error));
  },

  checkCart: async function () {
    const res = await fetch(`${routes.cart_url}.json`);
    const cart = await res.json();

    if (cart.items.some(item => item.properties['_bundleLocale'] && item.properties['_bundleLocale'] !== Shopify.locale)) {
      this.updateLineItemProperties(cart.items);
    }
  },

  updateLineItemProperties: async function(lineItems) {
    const lineItemsByBundleKey = lineItems.reduce((accumulator, lineItem) => {
      const bundleKey = lineItem.properties._bundleKey;
      if (bundleKey) {
        if (!accumulator[bundleKey]) {
          accumulator[bundleKey] = [];
        }
        accumulator[bundleKey].push(lineItem);
      }
      return accumulator;
    }, {});

    const bundleItems = Object.keys(lineItemsByBundleKey);

    for (const bundleKey of bundleItems) {
      const lineItems = lineItemsByBundleKey[bundleKey];

      lineItems.sort((a, b) => {
        const idsA = a.properties._bundleProductIds.split(',');
        const idsB = b.properties._bundleProductIds.split(',');
        const positionA = idsA.indexOf(a.product_id.toString());
        const positionB = idsB.indexOf(b.product_id.toString());
        return positionA - positionB;
      });

      const productTitles = lineItems.map(item => item.product_title).join(',');
      const variantTitles = lineItems.map(item => item.variant_title).join(',');
      const properties = {
        '_bundleProductTitles': productTitles,
        '_bundleVariantsTitles': variantTitles,
        '_bundleLocale': Shopify.locale
      };

      for (const item of lineItems) {
        const response = await fetch(`${routes.cart_change_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: item.key,
            properties: Object.assign({}, item.properties, properties),
          }),
        });
      }

      document.dispatchEvent(new CustomEvent('cart:updateDrawer'));
    }
  }
}

Woolman.init();

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, wait) {
  let t = false;
  return (...args) => {
    if (!t) {
      fn.apply(this, args)
      t = true;
      setTimeout(() => t = false, wait)
    }
  }
}

/**
 * Allow us to trigger something when window is actually resized.
 */
let woolman_window_size = window.innerWidth;
window.addEventListener(
  'resize',
  debounce(() => {
    if (window.innerWidth == woolman_window_size) {
      return;
    }
    woolman_window_size = window.innerWidth;
    document.dispatchEvent(new CustomEvent('woolman:resize'));
  }),
  250
);

window.processingSplider = false;
class SpliderParent extends HTMLElement {
  constructor() {
    'use strict';
    super();

    const styles = getComputedStyle(this);
    const perPage = parseInt(styles.getPropertyValue('--items-per-row-desktop')) || 3;
    const perPageTablet = parseInt(styles.getPropertyValue('--items-per-row-tablet')) || perPage;
    const perPageMobile = parseInt(styles.getPropertyValue('--items-per-row-mobile')) || 2;
    const gap = styles.getPropertyValue('--gap') || getComputedStyle(document.documentElement).getPropertyValue('--grid-gap-product');

    if (!this.hasAttribute('data-has-thumbnail')) {
      // Default sliders
      this.config = this.dataset.splide
        ? JSON.parse(this.dataset.splide)
        : {
          perPage: perPage,
          perMove: 1,
          drag: 'free',
          gap: gap,
          snap: true,
          autoWidth: true,
          lazyLoad: 'nearby',
          pagination: false,
          arrows: true,
          dragMinThreshold: 50,
          flickPower: 300,
          flickPages: 1,
          breakpoints: {
            1023: {
              perPage: perPageTablet,
              arrows: true
            },
            767: {
              perPage: perPageMobile,
              arrows: false
            }
          }
        };
    } else {
      // Product slider with thumbnails below
      this.config = {
        pagination: false
      };

      this.thumbConfig = {
        rewind: true,
        isNavigation: true,
        arrows: false,
        gap: gap,
        pagination: false,
        perPage: 4,
        dragMinThreshold: {
          mouse: 4,
          touch: 10,
        },
      };
    }

    this.el = this;
    this.splide = undefined;

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.downloadAndMount();
      }
    });

    /* Spliders are always lazily loaded. First we check if we can mount it or not */
    const mobileOnly = this.hasAttribute('data-mobile-only');
    const desktopOnly = this.hasAttribute('data-desktop-only');

    if (mobileOnly === false && desktopOnly === false) {
      // Slider is meant to be used for all devices, allow mounting immediately
      this.allowMounting();
    } else {
      document.addEventListener('woolman:resize', () => {
        this.checkIfCanMount(mobileOnly, desktopOnly);
      });
      this.checkIfCanMount(mobileOnly, desktopOnly);
    }

    if (Shopify && Shopify.designMode) {
      this.el.dataset.splideConfig = JSON.stringify(this.config)
    }
  }

  setupListeners() {
    const parentSection = this.closest('.shopify-section');
    parentSection.addEventListener('shopify:block:select', function (event) {
      const blockSelectedIsSlide = event.target.classList.contains('splide__slide');
      const currentSliderId = event.target.closest('slider-component').dataset.id;

      if (!blockSelectedIsSlide || !this.splide || this.dataset.id != currentSliderId) return;

      const index = parseInt(event.target.dataset.index);
      this.splide.go(index);

      const autoplay = this.splide.Components.Autoplay;
      autoplay.pause();
    }.bind(this));

    parentSection.addEventListener('shopify:block:deselect', function (event) {
      const blockSelectedIsSlide = event.target.classList.contains('splide__slide');
      const currentSliderId = event.target.closest('slider-component').dataset.id;

      if (!blockSelectedIsSlide || !this.splide || this.dataset.id != currentSliderId) return;

      const autoplay = this.splide.Components.Autoplay;
      autoplay.play();
    }.bind(this));
  }

  checkIfCanMount(mobileOnly, desktopOnly) {
    const breakpoint = 768;

    if (mobileOnly && woolman_window_size < breakpoint) {
      // Slider is for mobile devices only, allow mounting immediately
      this.allowMounting();
      return;
    }
    if (desktopOnly && woolman_window_size >= breakpoint) {
      // Slider is for desktop devices only, allow mounting immediately
      this.allowMounting();
      return;
    }
    this.disallowMounting();
  }

  /**
   * This function is called when we are sure that we can mount the slider. It will call downloadAndMount() which downloads the splider script and proceeds to mount it.
   * @param {boolean*} skipClassGeneration - If true, the required classes will not be generated and are assumed to exist already in HTML.
   */
  allowMounting(skipClassGeneration = false) {
    if (!skipClassGeneration) {
      this.classList.add('splide');
      this.querySelectorAll('[data-class]').forEach((elem) => {
        elem.classList.add(elem.dataset.class.split(' '));
      });
    }

    if (!this.hasAttribute('data-skip-observe')) {
      this.observer.observe(this.el);
    } else {
      this.downloadAndMount();
    }
  }

  disallowMounting() {
    if (this.splide) {
      this.splide.destroy(true);
      this.el.classList.remove('is-initialized');
    }

    this.classList.remove('splide');
    this.querySelectorAll('[data-class]').forEach((elem) => {
      elem.classList.remove(elem.dataset.class.split(' '));
    });

    this.observer.unobserve(this.el);
  }

  /**
   * This function downloads the splider script and proceeds to mount it.
   */
  downloadAndMount() {
    const sliderAssetUrl = theme.assets.slider;
    const existingScript = document.querySelector(`script[src="${sliderAssetUrl}"]`);

    // If we are already processing one slider, wait a while and try again.
    if (window.processingSplider) {
      setTimeout(this.downloadAndMount.bind(this), 200);
      return;
    }

    // Slider script was already found in document, proceed to immediately mount slider
    if (existingScript) {
      this.mountSlider();
      return;
    }

    // Slider script was not found in document, download it and wait for it to load, then mount the slider
    window.processingSplider = true;
    const script = document.createElement('script');
    script.setAttribute('defer', 'true');
    script.setAttribute('async', 'true');
    script.src = sliderAssetUrl;
    document.body.append(script);

    script.addEventListener('load', () => {
      this.mountSlider();
    });
  }

  /**
   * This function mounts the slider.
   */
  mountSlider() {
    this.splide = new Splide(this.el, this.config);

    if (this.thumbConfig) {
      const thumbEl = document.getElementById(this.getAttribute('data-has-thumbnail'));
      this.thumbSplide = new Splide(thumbEl, this.thumbConfig);
      this.splide.sync(this.thumbSplide);
    }

    this.splide.mount();

    if (this.thumbSplide) {
      this.thumbSplide.mount();
    }

    if (this.querySelector('.natural')) {
      this.splide.on('resize arrows:updated', this.updateHeight.bind(this));
      this.updateHeight();
    }

    this.observer.unobserve(this.el);
    this.dispatchEvent(new CustomEvent('mounted', { detail: { splide: this.splide } }));
    if (Shopify.designMode) { this.setupListeners() }; // editor listeners !

    window.processingSplider = false;
  }

  updateHeight() {
    const slide = this.splide.Components.Slides.getAt( this.splide.index ).slide;
    slide.parentElement.parentElement.style.height = slide.querySelector('.media').offsetHeight + 'px';
  }
}

if (customElements.get('slider-component') === undefined) {
  customElements.define('slider-component', SpliderParent);
}

class ProductSliderComponent extends SpliderParent {
  constructor() {
    super();
  }
  setActiveMedia(htmlElementId) {
    const mediaNode = document.querySelector(`[data-media-id="${htmlElementId}"]`);
    if (!mediaNode) return;

    if (!mediaNode.classList.contains('splide__slide')) {
      window.scrollTo({
        top: mediaNode.offsetTop,
        behavior: 'smooth'
      })
      return;
    }

    const mediaNodeIndex = parseInt(mediaNode.dataset.index - 1) || 0;
    this.splide.go(mediaNodeIndex);
  }
}
customElements.define('product-slider-component', ProductSliderComponent);

class DisclosureSelect extends HTMLElement {
  constructor() {
    super();

    const ALPHANUMERIC = { keyName: /^[a-z0-9]$/, keyCode: /^4[8-9]|5[0-7]|6[5-9]|[7-8][0-9]|90$/ };

    this.elements = {
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper')
    };

    this.keysSoFar = '';
    this.timeoutOn = false;

    this.options = this.querySelectorAll('.disclosure__link:not([data-ignore])');

    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.options.forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    this.addEventListener('keypress', this.handleKey(ALPHANUMERIC, this.focusOnClosest.bind(this)).bind(this));

    // Close panel if user clicks outside the div
    document.addEventListener('click', (e) => {
      if(e.target.closest('disclosure-select')) return

      this.hidePanel();
    });

    const mutationConfig = { attributes: true, childList: true };

    const callback = function(mutationsList) {
      if (mutationsList.find(mutation => mutation.type == 'childList')) {
        this.querySelectorAll('.disclosure__link:not([data-ignore])').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      }
    }.bind(this);

    const observer = new MutationObserver(callback);
    observer.observe(this.elements.panel.querySelector('ul'), mutationConfig);


  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();

    if (this.querySelector('.disclosure__link--active')) {
      this.querySelector('.disclosure__link--active').parentNode.setAttribute('aria-selected', 'false');
      this.querySelector('.disclosure__link--active').classList.remove('disclosure__link--active');
    }

    event.currentTarget.classList.add('disclosure__link--active');
    event.currentTarget.parentNode.setAttribute('aria-selected', 'true');

    this.elements.button.querySelector('.disclosure-current').innerHTML = event.currentTarget.innerHTML;
    this.dispatchEvent(new CustomEvent('change', { detail: { element: event.currentTarget } }));

    this.hidePanel();
  }

  openSelector() {
    this.elements.panel.toggleAttribute('hidden');
    this.elements.panel.querySelector('ul').focus();
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';

    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }

  handleKey(key, eventHandler) {
    return (event) => {
      event.preventDefault();

      const regexKey = new RegExp(key.keyName);
      const regexKeyCode = new RegExp(key.keyCode);

      if (regexKey.test(event.key) || regexKeyCode.test(event.keyCode)) {
        eventHandler(event);
      }
    }
  }

  focusOnClosest(event) {
    this.keysSoFar += event.key;

    if (!this.timeoutOn) {
      this.timeoutOn = true;

      setTimeout(function () {
        const closestOption = Array.from(this.querySelectorAll('.disclosure__link:not([data-ignore])')).find((option) => {
          const textContent = option.textContent.trim().toLowerCase();

          return textContent.startsWith(this.keysSoFar);
        });

        if (closestOption) {
          closestOption.focus();
        }

        this.keysSoFar = '';
        this.timeoutOn = false;
      }.bind(this), 300);
    }
  }
}

customElements.define('disclosure-select', DisclosureSelect);

// Custom element that enhances HTML Video Element functionality.
// Usage: <video is="superpowered-video">
class SuperPoweredVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video') || this.querySelector('iframe');
    if (this.closest('.video-container')) this.attachClickListener(this.closest('.video-container'));

    // check if video is iframe and has a src and that src is youtube
    if (this.video.nodeName === 'IFRAME' && this.video.src && this.video.src.includes('youtube')) {
      this.video.addEventListener('load', this.onVideoLoad.bind(this));
    }
  }

  attachClickListener(videoContainer) {
    if (!videoContainer) return;
    videoContainer.addEventListener('click', (e) => {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    });

    this.video.onplay = () => {
      videoContainer.querySelector('button').hidden = true;
    }

    this.video.onpause = () => {
      videoContainer.querySelector('button').hidden = false;
    }
  }

  onVideoLoad() {
    // force youtube to play on mobile
    this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }
}
customElements.define('superpowered-video', SuperPoweredVideo);

class ProductCardVariants extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantInput() {
    const productForm = document.getElementById(`product-form-${this.dataset.productId}`);
    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.productId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const productForm = document.getElementById(`product-form-${this.dataset.productId}`);
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&view=wishlist`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.productId}`);
        const source = html.getElementById(`price-${this.dataset.productId}`);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.productId}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    );
  }
}

customElements.define('product-card-variants', ProductCardVariants);



class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            if (this.querySelector('[data-placeholder]')) {
              this.querySelector('[data-placeholder]').innerHTML = recommendations.innerHTML;
            } else {
              this.innerHTML = recommendations.innerHTML;
            }
          }

          const name = this.querySelector('header.section__header .heading')?.innerText.trim();
          setTimeout(() => {
            const eventData = {
              name,
              products: []
            };
            this.querySelectorAll('[data-product-json]').forEach((product) => {
              eventData.products.push(JSON.parse(product.textContent));
            });
            document.dispatchEvent(new CustomEvent('productListView', { detail: eventData }));

            this.querySelectorAll('.card--product').forEach((card, index) => {
              const product = JSON.parse(card.querySelector('[data-product-json]').textContent);
              card.addEventListener('click', (e) => {
                const clickEvent = new CustomEvent("productListClick", {
                  detail: {
                    name,
                    product,
                    index
                  }
                });
                document.dispatchEvent(clickEvent);
              });
            });
          }, 0);

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

(function() {
  const updateCartQueue = [];
  window.updateCart = function (params) {
    updateCartQueue.push(params);
    return new Promise((resolve, reject) => {
      const interval = setInterval(() => {
        if (updateCartQueue.indexOf(params) === 0) {
          clearInterval(interval);
          fetch('/cart/update.json', params)
            .then((res) => resolve(res))
            .catch((err) => reject(err))
            .finally(() => updateCartQueue.splice(0, 1));
        }
      }, 25);
    });
  };

  window.fetchCart = async function () {
    const res = await fetch('/cart.json');
    const cart = await res.json();
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart:fetch', { detail: cart }));
    })
    return cart;
  }

  window.getCookieValue = function (name) {
    const cookie = document.cookie.split(';').find((c) => c.trim().startsWith(`${name}=`))
    if (!cookie) {
      return null
    }
    return decodeURIComponent(cookie.split('=')[1])
  }

  window.removeCookie = function (name) {
    if (window.getCookieValue(name)) {
      document.cookie = `${name}=;domain=.danielwellington.com;max-age=-1;samesite=strict;path=/`
      return true
    }
    return false
  }
})();

const klarnaCountries = ['FI', 'DE', 'AT', 'FR', 'IT', 'DK', 'NO', 'SE'];
if (klarnaCountries.includes(window.Shopify.country)) {
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    klarna-placement::part(osm-container) {
      display: flex !important;
    }
  `;
  document.body.appendChild(styleElement);
}
